// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title{font-family:LaPrairie;display:flex;flex-direction:column;text-transform:uppercase;color:#4b4b4b;font-weight:400;font-size:2.1875rem}", ""]);
// Exports
module.exports = exports;
